import Flag from "../../../assets/img/flag.svg";

export interface LanguageSwitchProps {
  /** current language code, for example "es" or "en-us" */
  currentLang: string;
  /** true while the change is being saved; blocks clicks */
  isLangChanging?: boolean;
  /** called with the other language: "es" or "en-us" */
  onChange: (lang: string) => void;
}

/** EN / ES pill. Shows the current language; a click switches to the other. */
const LanguageSwitch = ({
  currentLang,
  isLangChanging = false,
  onChange,
}: LanguageSwitchProps) => {
  const isSpanish = currentLang?.toLowerCase().startsWith("es");
  const next = isSpanish ? "en-us" : "es";
  const change = () => {
    if (!isLangChanging) onChange(next);
  };

  return (
    <div
      className={`language-switch-container${
        isSpanish ? " language-switch-container-es" : ""
      }${isLangChanging ? " disabled" : " cursor-pointer"}`}
      onClick={change}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          change();
        }
      }}
      aria-label={isSpanish ? "Switch to English" : "Cambiar a Español"}
    >
      {isSpanish ? (
        <>
          <p>ES</p>
          <img className="flag-image" alt="" src="/images/spain-flag.png" />
        </>
      ) : (
        <>
          <img className="flag-image" alt="" src={Flag} />
          <p>EN</p>
        </>
      )}
    </div>
  );
};

export default LanguageSwitch;
